import React, { useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import cx from 'clsx'
import { useSpring, animated } from 'react-spring'
import SVG from 'react-inlinesvg'
// Material-UI
import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
// Components
import Link from '~2023/components/Link'
import Menu from '~2023/components/Menu'
import ContainerCategory from '~2023/components/ContainerCategory'
import { LogoIcon } from '~2023/components/Icons'
// Hooks
import { useScrollPosition } from '@n8tb1t/use-scroll-position'
import useSiteMeta from '~2023/hooks/useSiteMeta'
// Styles
import useStyles from './Header.style'

const filterSelector = (state) => state.filter

const Header = () => {
  const headerRef = useRef()
  const classes = useStyles()
  const siteMeta = useSiteMeta()
  const { title: siteTitle } = siteMeta

  const {
    fandom: { rank: fandomRank },
  } = useSelector(filterSelector)

  const [isScrollDown, setIsScrollDown] = useState(false)
  const handleScrollPositionCallback = ({ prevPos, currPos }) => {
    if (0 >= currPos.y) {
      setIsScrollDown(false)
    } else {
      const isShow = currPos.y > prevPos.y
      if (isShow !== isScrollDown) {
        setIsScrollDown(isShow)
      }
    }
  }
  /**
   * @note
   * useScrollPosition(effect, deps, element, useWindow, wait)
   */
  useScrollPosition(
    handleScrollPositionCallback,
    [isScrollDown],
    headerRef,
    true,
    100
  )

  const { marginTop } = useSpring({
    config: {
      duration: 150,
      friction: 60,
      mass: 1,
      tension: 280,
    },
    // @note Determine if we are in a Fandom Detail
    marginTop: `${isScrollDown && 0 === fandomRank ? -13 : 0}rem`,
  })

  return (
    <animated.header
      className={cx(classes.header)}
      itemScope
      itemType="http://schema.org/WPHeader"
      ref={headerRef}
      style={{ marginTop, width: '100%' }}
    >
      <Container maxWidth="xl">
        <Grid
          alignContent="center"
          alignItems="center"
          container
          direction="row"
          justify="space-between"
        >
          <Grid item xs>
            <animated.div className={cx(classes.siteMenu)}>
              <Menu />
              <Link className={cx(classes.siteLogo)} to="/">
                <SVG
                  description="Fansided250 Logo"
                  height={30}
                  src={LogoIcon}
                  title={siteTitle}
                  width={115}
                />
              </Link>
            </animated.div>
          </Grid>
          <Grid item xs>
            <animated.div className={cx(classes.buttonBox)}>
              <ContainerCategory />
            </animated.div>
          </Grid>
        </Grid>
      </Container>
    </animated.header>
  )
}

export default Header
